const browserSessionStorageKey = 'microsites-browser-session-id';

function generateBrowserSessionId(): string {
  if (typeof crypto === 'undefined' || typeof crypto.randomUUID !== 'function') {
    throw new Error('crypto.randomUUID is required');
  }
  return crypto.randomUUID();
}

export function getBrowserSessionId(): string {
  const existing = window.localStorage.getItem(browserSessionStorageKey)?.trim();
  if (existing) {
    return existing;
  }

  const browserSessionId = generateBrowserSessionId();
  window.localStorage.setItem(browserSessionStorageKey, browserSessionId);
  return browserSessionId;
}